// @flow
import React from 'react';
import PropTypes from 'prop-types';
import SnackBar from '../../../../elements/SnackBar/SnackBar';
import ButtonAccordion from '../../components/ButtonAccordion/ButtonAccordion';
import AccountInformation from './AccountInformation';
import SecurityInformation from './SecurityInformation';
import PaymentInformation from './PaymentInformation';
// import ReferralInformation from './ReferralInformation';

import type {
  User,
  Subscription,
  SubscriptionSetting,
  Store,
} from '../../../../entities';
import type {SaveAccountRequest} from '../../api';
import ReferralInformation from './ReferralInformation';

type Props = {|
  user: User,
  store: Store,
  saveAccountSettings: (data: SaveAccountRequest) => void,
  isSaving?: boolean,
  resetState: () => void,
  error?: string,
  savingSuccess?: boolean,
  cardProfiles?: Object[],
  subscription?: Subscription,
  dueInformation?: Subscription,
  fetchCards: () => void,
  subscriptionSetting?: SubscriptionSetting,
  saveSubscriptionSetting: ({automaticCharge: boolean}) => void,
|};

export default function Account(props: Props) {
  const {
    user,
    savingSuccess,
    saveAccountSettings,
    // resetState,
    isSaving,
    store,
    error,
    subscription,
    cardProfiles,
    // fetchCards,
    subscriptionSetting,
    saveSubscriptionSetting,
  } = props;

  const accordionOptions = [
    {
      enabled: true,
      title: 'Información de Cuenta',
      content: (
        <AccountInformation
          user={user}
          saveAccountSettings={saveAccountSettings}
          isSaving={isSaving}
        />
      ),
    },
    {
      enabled: user && user.type === 'vendor-user',
      title: 'Información de Seguridad',
      content: <SecurityInformation isSaving={isSaving} />,
    },
    {
      enabled: user && user.type === 'vendor-user',
      title: 'Información de Pago',
      content: (
        <PaymentInformation
          store={store}
          subscription={subscription}
          cardProfiles={cardProfiles}
          subscriptionSetting={subscriptionSetting}
          saveSubscriptionSetting={saveSubscriptionSetting}
        />
      ),
    },
  ];

  // useEffect(() => () => resetState(), [resetState]);

  // useEffect(() => {
  //   fetchCards();
  // }, [fetchCards]);

  return (
    <div>
      <SnackBar mode="error" message={error} />
      <SnackBar
        mode="success"
        message={savingSuccess ? 'Se guardaron los cambios' : undefined}
      />
      {accordionOptions.map((item, index: number) =>
        item.enabled ? (
          <ButtonAccordion
            key={`accordion-${index}`}
            title={item.title}
            content={item.content}
          />
        ) : null
      )}
      <ReferralInformation />
    </div>
  );
}

Account.propTypes = {
  store: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  subscription: PropTypes.object,
  dueInformation: PropTypes.object,
  saveAccountSettings: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
  savingSuccess: PropTypes.bool,
  cardProfiles: PropTypes.array,
  fetchCards: PropTypes.func,
  subscriptionSetting: PropTypes.object,
  saveSubscriptionSetting: PropTypes.func.isRequired,
};
